module.exports = __webpack_public_path__ + "static/media/close.82f503ec.svg";